module.exports = __webpack_public_path__ + "static/media/saveImg.35ac9232.svg";